import React from "react";

import { Container } from "@ui/Atoms/Grid";
import { FadeInContainer, Margins } from "@ui/Atoms";
import { MobileSectionTitle } from "@ui/Molecules";

import { ScrollToTop } from "@containers/ScrollToTop";

import { useTranslate } from "@hooks/useTranslate";

import { ContactForm } from "@app/containers/ContactForm";

const Support = (): React.ReactElement => {
  const translate = useTranslate();

  return (
    <FadeInContainer>
      <ScrollToTop />
      <Container>
        <Margins xs={["base_x4", null, null, null]}>
          <MobileSectionTitle withoutMarginBottom>
            {translate("batmaid_pwa_navigation.subnav_support")}
          </MobileSectionTitle>
        </Margins>
        <ContactForm />
      </Container>
    </FadeInContainer>
  );
};

export { Support };
